import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    editTraineesRequest: ['response'],
    editTraineesSuccess: ['loading', 'response'],
    editTraineesFailure: ['error'],
})

export const editTraineesTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    success: null,
    error: null,
})

/* ------------- Reducers ------------- */

const editTraineesRequest = state => state.merge({ success: null })

const editTraineesSuccess = (state, { response }) =>
    state.merge({
        success: true,
        error: false,
        response,
    })

const editTraineesFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        response,
    })
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.EDIT_TRAINEES_REQUEST]: editTraineesRequest,
    [Types.EDIT_TRAINEES_SUCCESS]: editTraineesSuccess,
    [Types.EDIT_TRAINEES_FAILURE]: editTraineesFailure,
})
